import { ValidationResult } from '../formField/types/form-validator';
import { Observable } from 'rxjs';

export const RemoteValidator = (
  remoteValidator: (value: unknown) => Observable<unknown>,
  validate: (response: unknown) => boolean,
  errorMessage: ((response: unknown) => string) | string,
  connectErrorMessage: string,
  delayCallbackTime?: number
) => {
  let lastValue;
  return async (value: unknown): Promise<ValidationResult> => {
    try {
      if (!value) {
        return { valid: true };
      }

      if (delayCallbackTime) {
        lastValue = value;
        const delayPromise = new Promise(resolve => setTimeout(resolve, delayCallbackTime));
        await delayPromise;
        if (lastValue !== value) {
          return { valid: true };
        }
      }

      const response = await remoteValidator(value).toPromise();
      if (response && validate(response)) {
        return { valid: true };
      }

      return {
        valid: false,
        error: typeof errorMessage === 'string' ? errorMessage : errorMessage(response),
      };
    } catch (error) {
      return { valid: false, error: typeof errorMessage !== 'string' ? errorMessage(error) : connectErrorMessage };
    }
  };
};
